export const scopes = [
  {
    value: 'Categories',
    label: 'CATEGORIES'
  },
  // {
  //   value: 'Brands',
  //   label: 'BRANDS'
  // },
  {
    value: 'Products',
    label: 'PRODUCTS'
  },
  {
    value: 'User',
    label: 'USER'
  }
];
